import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Grid, Typography } from '@mui/material';
import { RadioListItem } from 'components/Input/Radio';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import { TextBoxItem } from 'components/Input/TextBox';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { BtnAdd, BtnBack, BtnDuplicate, BtnRemark, BtnSave } from 'components/Button/ButtonAll';
import { useLocation, useNavigate } from 'react-router';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import InputNumberItem from 'components/Input/InputNumber';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import { TextAreaItem } from 'components/Input/TextArea';
import moment from 'moment';
import { AutoCompleteItem } from 'components/Input/AutoComplete';
const MaterialWithdrawBorrowForm = () => {
    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const navigate = useNavigate();
    const onBack = () => navigate("/MaterialInventoryList?sMode=" + sMode);
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [arrMaterialType, setMaterialType] = useState<any>([]);
    const [arrMaterial, setMaterial] = useState<any>([]);
    const [arrMaterial2, setMaterial2] = useState<any>([]);
    const [arrMaterial3, setMaterial3] = useState<any>([]);
    const [isOpen, setisOpen] = useState<boolean>(false);
    const [sRemark, setsRemark] = useState("");
    const [sDetail, setsDetail] = useState("");
    const [sOrder, setsOrder] = useState("");
    const [nReceiveType, setReceiveType] = useState(0);
    const sMode = new URLSearchParams(searchParams).get("sMode");
    const [nDupYear, setnDupYear] = useState(1);
    const [loadingTable, setLoadingTable] = useState(false);
    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission
    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);


    const dataColumn: any = [
        {
            field: "nOrder",
            headerName: "ที่",
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            width: 50,
            disableColumnMenu: true,
        },
        {
            field: "nMaterialTypeID",
            headerName: "ประเภทวัสดุ",
            headerAlign: "center",
            align: "Left",
            sortable: false,
            flex: 1,
            width: 220,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        ประเภทวัสดุ
                        <span style={{ color: "red" }}> * </span>
                    </Typography>

                )
            },
            renderCell: (item) => {
                return (
                    <FormProvider {...form}>
                        <SelectItem
                            id={`nMaterialTypeID_${item.row.sID}`}
                            name={`nMaterialTypeID_${item.row.sID}`}
                            options={arrMaterialType}
                            required={true}
                            disabled={!isPermission || sID != null}
                            placeholder={`${I18n.SetText("Material.sNameMaterialtype")}`}
                            IsShowMessageError={false}
                            onChange={(e) => {
                                getMaterial(e ? e.value : null, item.row.sID, sMode)
                                getMaterialUnit(e ? e.sUnit : null, item.row.sID, e ? e.nTotalAmount : null, e ? e.nRemaining : null)
                            }}
                        />
                    </FormProvider>
                )
            }
        },
        {
            field: "nMaterialID",
            headerName: "รายการ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 1,
            width: 220,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        รายการ
                        <span style={{ color: "red" }}> * </span>
                    </Typography>

                )
            },
            renderCell: (item) => {
                return (
                    <FormProvider {...form}>
                        <SelectItem
                            id={`nMaterialID_${item.row.sID}`}
                            name={`nMaterialID_${item.row.sID}`}
                            placeholder={`${I18n.SetText("Material.sMaterial")}`}
                            options={form.getValues(`nMaterialTypeID_${item.row.sID}`) == 2 ? arrMaterial2 : form.getValues(`nMaterialTypeID_${item.row.sID}`) == 3 ? arrMaterial3 : arrMaterial}
                            required={true}
                            disabled={!isPermission || sID != null}
                            IsShowMessageError={false}
                            onChange={(e) => {
                                getMaterialUnit(e ? e.sUnit : null, item.row.sID, e ? e.nTotalAmount : null, e ? e.nRemaining : null)
                            }}
                        />
                    </FormProvider>
                )
            }
        },
        {
            field: "sUnit",
            headerName: "หน่วยนับ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 100,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        หน่วยนับ
                        <span style={{ color: "red" }}> * </span>
                    </Typography>

                )
            },
        },
        {
            field: "nTotalAmount",
            headerName: "พร้อมยืม",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 100,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        พร้อมยืม
                        <span style={{ color: "red" }}> * </span>
                    </Typography>

                )
            },
        },
        {
            field: "nAmount",
            headerName: "ยืม",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 130,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        ยืม
                        <span style={{ color: "red" }}> * </span>
                    </Typography>

                )
            },
            renderCell: (item) => {
                return (
                    <FormProvider {...form}>
                        <InputNumberItem
                            id={`nAmount_${item.row.sID}`}
                            name={`nAmount_${item.row.sID}`}
                            required={true}
                            IsCanMinus={true}
                            IsShowMessageError={false}
                            IsAllowScientific={true}
                            disabled={!isPermission || sID != null}
                            max={item.row.nTotalAmount}
                            onChange={() => {
                                nSum(item.row.sID);
                            }}
                            maxDigits={0}
                            ShowDigits={0}
                            maxInteger={10}
                            IsComma={true}
                        />
                    </FormProvider>
                )
            }
        },

        {
            field: "nRemaining",
            headerName: "คงเหลือ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 120,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        คงเหลือ
                        <span style={{ color: "red" }}> * </span>
                    </Typography>

                )
            },
        },
        {
            field: "sRemark",
            headerName: "หมายเหตุ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 80,

            disableColumnMenu: true,
            renderCell: (item) => {
                return (
                    <>
                        <BtnRemark
                            id={"btn" + item.row.sID}
                            IsCircleWithOutText
                            className='btnicon-remark'
                            onClick={() => onOpenModal(item.row.sID, item.row.sRemark, item.row.sDetail)}
                        />

                    </>
                );

            },
        },

    ];

    const getFormInitial = () => {
        AxiosFn.Get(`MaterialInventory/GetFormInitial`, {}, (result) => {
            setMaterialType(result.lstMaterialTypeBorrow);

        })
    }

    const getMaterial = (nMaterialTypeID, nOrder, sMode) => {
        let Param = {
            nMaterialTypeID: nMaterialTypeID,
            nWithdrawType: 2,
            nWithdrawDate: form.getValues("dWithdraw") ? form.getValues("dWithdraw").valueOf() : null
        };
        if (nMaterialTypeID == null) {
            form.setValue(`nMaterialID_${nOrder}`, null);
        }
        AxiosFn.Post(`MaterialInventory/GetMaterialWithdraw`, Param, (result) => {
            if (nMaterialTypeID == 1) {
                setMaterial(result.lstMaterial);
            } else if (nMaterialTypeID == 2) {
                setMaterial2(result.lstMaterial);
            } else if (nMaterialTypeID == 3) {
                setMaterial3(result.lstMaterial);
            }
        })
    }

    //หาหน่วย
    const getMaterialUnit = (sUnit, sID, nTotalAmount, nRemaining) => {
        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.sUnit = f.sID == sID ? sUnit : f.sUnit;
                f.nTotalAmount = f.sID == sID ? nTotalAmount : f.nTotalAmount;
                f.nRemaining = f.sID == sID ? nRemaining : f.nRemaining;
            });
        }
        setDataRow({ ...arrClone });
        if (nTotalAmount > 0) {
            nSum(sID)
        }
    }

    //คำนวณยอดคงเหลือ
    const nSum = (sID) => {
        let nAmount = form.getValues(`nAmount_${sID}`);
        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.nRemaining = f.sID == sID ? f.nTotalAmount - nAmount : f.nRemaining;
            });
        }
        setDataRow({ ...arrClone });

    }

    //บันทึกหมายเหตุ
    const onOpenModal = (sIDRow, sRemark, sDetail) => {
        setisOpen(true);
        setsOrder(sIDRow);
        form.setValue("sRemark", sRemark);
        form.setValue("sDetail", sDetail);
        setsRemark(form.getValues(`sRemark`));
        setsDetail(form.getValues(`sDetail`));

    };
    const onSummitRemark = () => {
        setisOpen(false);
        let sDetailform = form.getValues(`sDetail`);
        let sRemarkform = form.getValues(`sRemark`);

        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.sDetail = f.sID == sOrder ? sDetailform : f.sDetail;
                f.sRemark = f.sID == sOrder ? sRemarkform : f.sRemark;
            });
        }
        setDataRow({ ...arrClone });
    }

    //Add TableItem
    const onSumitTable = (e) => {
        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.sID = f.sID;
                f.nOrder = f.nOrder;
                f.nMaterialTypeID = e[`nMaterialTypeID_${f.sID}`] ? e[`nMaterialTypeID_${f.sID}`] : f.nMaterialTypeID;
                f.nMaterialID = e[`nMaterialID_${f.sID}`] ? e[`nMaterialID_${f.sID}`] : f.nMaterialID;
                f.sUnit = f.sUnit;
                f.nAmount = e[`nAmount_${f.sID}`] ? +e[`nAmount_${f.sID}`] : f.nAmount;
                f.nTotalAmount = f.nTotalAmount;
                f.nRemaining = f.nRemaining;
                f.sRemark = f.sRemark != "" ? f.sRemark : sRemark;
                f.sDetail = f.sDetail != "" ? f.sDetail : sDetail;
            });
        }

        let arrNewItem = [];
        let arrID =
            arrClone.arrRows.length > 0 ? arrClone.arrRows.map((m) => m.sID) : [];
        let nID = (arrID.length > 0 ? Math.max(...arrID) : 0) + 1;
        arrNewItem.push(...arrClone.arrRows);


        //Add New Item 
        let arrIDOnItem = arrNewItem.map((m) => m.nWithdrawItemID);
        let arrOrderOnItem = arrNewItem.map((m) => m.nOrder);

        let sID = arrNewItem.length > 0 ? Math.max(...arrIDOnItem) + 1 : nID;


        let objNewItem: MaterialWithdrawIItem = {};
        objNewItem.sID = sID + "";
        objNewItem.nOrder = arrNewItem.length > 0 ? Math.max(...arrOrderOnItem) + 1 : nID;
        objNewItem.nMaterialTypeID = 0;
        objNewItem.nMaterialID = 0;
        objNewItem.nAmount = 0;
        objNewItem.nRemaining = 0;
        objNewItem.nTotalAmount = 0;
        objNewItem.nWithdrawID = sID;
        objNewItem.nWithdrawItemID = sID;
        arrNewItem.push(objNewItem);
        arrClone.arrRows = [...arrNewItem];
        setDataRow({ ...arrClone });

    };

    //ลบข้อมูลในตาราง
    const handleDelete = (arrID) => {
        DialogFn.Submit(`${I18n.SetText("Material.sConfirmDel")}`, () => {
            let arrClone = dataRow;
            arrClone.arrRows = arrClone.arrRows.filter((f) => !arrID.includes(f.sID));

            // เรียง Order ใหม่
            if (arrClone.arrRows.length > 0) {
                let nOrder = 1;
                arrClone.arrRows.forEach((f) => {
                    f.nOrder = nOrder;
                    nOrder++;
                });
            }
            setDataRow({
                ...arrClone,
                nDataLength: arrClone.arrRows.length,
            });
            DialogFn.Success("ลบข้อมูลสำเร็จ");
        });
    };

    // บันทึกเบิก
    const onSubmit = (e, sMode, nDupYear) => {
        let lstDataType = []
        let lstData = []
        lstData = dataRow.arrRows;
        lstData.forEach((item) => {
            lstDataType.push({
                sID: item.sID,
                nOrder: item.nOrder,
                nMaterialTypeID: e[`nMaterialTypeID_${item.sID}`] ? e[`nMaterialTypeID_${item.sID}`] : item.nMaterialTypeID,
                nMaterialID: e[`nMaterialID_${item.sID}`] ? e[`nMaterialID_${item.sID}`] : item.nMaterialID,
                sUnit: item.sUnit,
                nAmount: e[`nAmount_${item.sID}`] ? +e[`nAmount_${item.sID}`] : item.nAmount,
                nTotalAmount: item.nTotalAmount,
                nRemaining: item.nRemaining,
                sRemark: form.getValues("sRemark") ? form.getValues("sRemark") : item.sRemark,
                sDetail: form.getValues("sDetail") ? form.getValues("sDetail") : item.sDetail,
            })
        })

        let param = {
            sID: sID ? sID : "",
            sDocumentNo: form.getValues("sDocumentNo"),
            nWithdrawDate: form.getValues("dWithdraw").valueOf(),
            nReceiverUnitType: +form.getValues("sReceiverUnitType"),
            nReceiverID: form.getValues("nReceiverID") ? form.getValues("nReceiverID").value : 0,
            sExternalReceiver: form.getValues("sExternalReceiver") ? form.getValues("sExternalReceiver") : "",
            lstDataWithdraw: lstDataType,
            nWithdrawType: 2,
            nDupYear: nDupYear
        };

        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`MaterialInventory/SaveWithdrawMaterial`, param, (result) => {
                DialogFn.UnBlockUI();
                DialogFn.Success(`บันทึกสำเร็จ`);
                DialogFn.CloseSubmit()
                navigate("/MaterialInventoryList?sMode=" + sMode);
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    //ดึงข้อมูลมาแก้ไข
    const getReceiveMaterialEdit = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
            sID: sID ? sID : ""
        };
        DialogFn.BlockUI();
        AxiosFn.Post(`MaterialInventory/GetWithdrawMaterialEdit`, Param, (result) => {
            DialogFn.UnBlockUI();
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: [...result.lstDataWithdraw],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
            if (sID) {
                setTimeout(() => {
                    (result.lstDataWithdraw ?? []).forEach(f => {
                        f.nOrder = f.nOrder;
                        form.setValue(`nMaterialTypeID_${f.sID}`, f.nMaterialTypeID);
                        form.setValue(`nMaterialID_${f.sID}`, f.nMaterialID);
                        form.setValue(`nAmount_${f.sID}`, f.nAmount);
                        form.setValue(`nPricePerUnit_${f.sID}`, f.nPricePerUnit);
                        form.setValue(`sRemark`, f.sRemark);
                        form.setValue(`sDetail`, f.sDetail);
                        if (f.nMaterialTypeID == 1) {
                            setMaterial(result.lstMaterial);
                        } else if (f.nMaterialTypeID == 2) {
                            setMaterial2(result.lstMaterial);
                        } else if (f.nMaterialTypeID == 3) {
                            setMaterial3(result.lstMaterial);
                        }
                    })

                }, 300);
                form.setValue(`sExternalReceiver`, result.sExternalReceiver);
                form.setValue(`nReceiverID`, result.objReceiverID);
                form.setValue("sReceiverUnitType", result.nReceiverUnitType + "");
                form.setValue("dWithdraw", moment(result.nWithdrawDate));
                form.setValue("sDocumentNo", result.sDocumentNo);
                setReceiveType(result.nReceiverUnitType);
            }

        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };

    const onDuplicate = (e, nDup) => {
        form.setValue("dWithdraw", null);
        setnDupYear(nDup);
        let param = {

            lstDataRow: dataRow.arrRows
        }
        AxiosFn.Post(`MaterialInventory/GetWithdrawItem`, param, (result) => {
            setDataRow({
                ...dataRow,
                arrRows: result.lstMateriallWithdrawItem
            });

        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        )
    }

    useEffect(() => {
        getReceiveMaterialEdit(dataRow);
        getFormInitial();
    }, []);

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <DatePickerItem
                            required={true}
                            maxDate={moment()}
                            name={"dWithdraw"}
                            id={"dWithdraw"}
                            label={`${I18n.SetText("Material.sWithdrawaldateType2")}`}
                            fullWidth
                            disabled={!isPermission || (nDupYear == 2 ? false : sID != null)}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextBoxItem
                            required={true}
                            label={`${I18n.SetText("Material.sDocOrderNo")}`}
                            id={'sDocumentNo'}
                            name={'sDocumentNo'}
                            maxLength={250}
                            type={'text'}
                            IsShowMessageError
                            disabled={!isPermission}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}></Grid>
                    <Grid item container xs={12} md={12}>
                        <Grid item container xs={12} md={3} sx={{ marginBottom: "10px" }} >

                            <RadioListItem
                                id={"sReceiverUnitType"}
                                name={"sReceiverUnitType"}
                                required={true}
                                options={[
                                    { value: "1", label: `${I18n.SetText("Material.sFossilManagement")}` },
                                    { value: "2", label: `${I18n.SetText("Material.sExternal")}` },
                                ]}
                                onChange={(e) => {
                                    setReceiveType(e ? e : null)
                                    form.setValue(`nReceiverID`, null);
                                }}

                                disabled={!isPermission}
                                label={`${I18n.SetText("Material.sAgencyType2")}`}
                            />

                        </Grid>

                        <Grid item container xs={12} md={6} sx={{ marginTop: "17px" }} >
                            <Grid item xs={12} md={8} >
                                {nReceiveType == 1 &&
                                    <AutoCompleteItem
                                        id={`nReceiverID`}
                                        name={`nReceiverID`}
                                        sUrlAPI={`MaterialInventory/GetSearchUser`}
                                        label={`${I18n.SetText("Material.sUserType2")}`}
                                        placeholder={`${I18n.SetText("Material.sUserType2")}`}
                                        required={nReceiveType == 1}
                                        disabled={!isPermission}
                                        fullWidth
                                    />
                                }
                            </Grid>
                            <Grid item container xs={12} md={12} sx={{ marginTop: "17px" }} >
                                {nReceiveType == 2 &&
                                    <Grid item xs={12} md={12}>
                                        <TextBoxItem
                                            required={nReceiveType == 2}
                                            label={`${I18n.SetText("Material.sExternalReceiver")}`}
                                            id={'sExternalReceiver'}
                                            name={'sExternalReceiver'}
                                            maxLength={250}
                                            type={'text'}
                                            IsShowMessageError
                                            disabled={!isPermission}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <DataGrid
                            columns={dataColumn}
                            rows={dataRow}
                            isDisableColumnMenu={true}
                            onDelete={handleDelete}
                            isHiddenToolHead
                            isHiddenPagination
                            isShowCheckBox={isPermission || sID == null}
                            onRowSelectable={(p) => sID == null}
                            isLoading={loadingTable}

                        />
                    </Grid>

                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Grid container justifyContent="flex-start" xs={12} md={12} spacing={2}>
                            {sID == null &&
                                <Grid item>
                                    <BtnAdd id={"btnSave"}
                                        txt='เพิ่มข้อมูล'
                                        IsDisabled={!isPermission}
                                        onClick={form.handleSubmit((e) => { onSumitTable(e) })}
                                    />
                                </Grid>
                            }
                            {(sID != null && sMode === "WithdrawType2") &&
                                <Grid item gap={2}>
                                    <BtnDuplicate id={"btnDuplicate"} onClick={form.handleSubmit((e) => { onDuplicate(e, 2) })} />
                                </Grid>
                            }
                        </Grid>
                    </Grid>


                </Grid>
                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit(
                                (e) => onSubmit(e, sMode, nDupYear),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>

                <DialogPreview
                    IsOpen={isOpen}
                    IsBackdropClick={false}
                    onClose={() => { setisOpen(false); }}
                    JsxDialogAction
                    CloseSave={sID == null ? true : false}
                    onClick={() => { onSummitRemark(); }}
                    Close={true}
                    sMaxWidth='sm'
                    bgColor={"#a07300"}
                    Color='white'
                    Title={''}
                >
                    <Grid container justifyContent={"center"} >
                        {sMode == "Withdraw" &&
                            <Grid item xs={12} md={12}>
                                <TextAreaItem
                                    placeholder=""
                                    label='รายละเอียดเพิ่มเติม (จ่ายให้)'
                                    name={`sDetail`}
                                    maxLength={500}
                                    id={`sDetail`}
                                    required={false}
                                    disabled={!isPermission || sID != null}
                                />
                            </Grid>
                        }
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                placeholder=""
                                label='หมายเหตุ'
                                name={`sRemark`}
                                maxLength={500}
                                id={`sRemark`}
                                required={false}
                                disabled={!isPermission || sID != null}
                            />
                        </Grid>
                    </Grid>
                </DialogPreview >
            </FormProvider>
        </React.Fragment >
    );
}
export default MaterialWithdrawBorrowForm;

export interface MaterialWithdrawIItem {
    sID?: string;
    nMaterialTypeID?: number;
    nOrder?: number;
    nMaterialID?: number;
    nAmount?: number;
    nRemaining?: number;
    nTotalAmount?: number;
    nWithdrawID?: number;
    nWithdrawItemID?: number;
}

